import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles(() => ({
    dialog: {
        '&.MuiDialog-root': {
            zIndex: '999999999999!important',
        }
    },
    title: {
        background: '#08090a',
        padding: '4px 16px',

        '& .MuiTypography-root': {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            color: '#fff'
        },

        '& .MuiIconButton-root': {
            color: '#fff'
        }
    },
    dialogContent: {
        padding: '20px'
    },
    footer: {
        padding: '10px 20px',
        borderTop: '1px solid rgba(30, 40, 49, 0.3)'
    }
}))

export default useStyles;